import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'ig-expand-indicator',
  standalone: true,
  imports: [
    MatIcon,
    MatTooltip
  ],
  templateUrl: './expand.indicator.component.html',
  styleUrl: './expand.indicator.component.scss'
})
export class ExpandIndicatorComponent {
  @Input() color = '#71c5e95e';
  @Input() triggerText = '';
}
